import React from "react"
import { AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { getCurrentUser } from "../../../helpers/Utils"

const NotificationSelector = ({ lead }) => {
  // Don't render if lead holder is null or Administrator
  if (
    (lead && lead.leadholder_role == null) ||
    (lead && lead.leadholder_role == "Administrator")
  ) {
    return null
  }

  const currentUserRole = getCurrentUser()?.role_name

  const renderNotificationOptions = () => {
    const baseCheckboxes = []

    switch (currentUserRole) {
      case "Administrator":
        baseCheckboxes.push(
          <AvCheckbox
            key="team_leader"
            label="Team Leader"
            value="team_leader"
          />
        )
        // Only show Executive option if lead holder is not Team Leader
        if (lead.leadholder_role !== "Team Leader") {
          baseCheckboxes.push(
            <AvCheckbox key="executive" label="Executive" value="executive" />
          )
        }
        break

      case "Team Leader":
        baseCheckboxes.push(
          <AvCheckbox
            key="administrator"
            label="Administrator"
            value="administrator"
          />
        )
        // Only show Executive option if lead holder is not Team Leader
        if (lead.leadholder_role !== "Team Leader") {
          baseCheckboxes.push(
            <AvCheckbox key="executive" label="Executive" value="executive" />
          )
        }
        break

      case "Executive":
        baseCheckboxes.push(
          <AvCheckbox
            key="administrator"
            label="Administrator"
            value="administrator"
          />,
          <AvCheckbox
            key="team_leader"
            label="Team Leader"
            value="team_leader"
          />
        )
        break

      default:
        return null
    }

    return baseCheckboxes
  }

  const notificationOptions = renderNotificationOptions()

  if (!notificationOptions || notificationOptions.length === 0) {
    return null
  }

  return (
    <div className="mb-3 me-2">
      <label>Send Notification to:</label>
      <AvCheckboxGroup inline name="senior">
        {notificationOptions}
      </AvCheckboxGroup>
    </div>
  )
}

export default NotificationSelector
